import { Bookmark, BookmarkCheck } from "lucide-react";
import type { PublicProviderListRow } from "@appcaire/shared/seo";
import { useState } from "react";
import { useShortlist } from "./ShortlistContext";

export function ShortlistButton({ row }: { row: PublicProviderListRow }) {
  const { isSaved, toggle } = useShortlist();
  const providerId = row.providerId ?? row.id;
  const saved = isSaved(providerId);
  const [message, setMessage] = useState<string | null>(null);

  return (
    <div>
      <button
        type="button"
        onClick={() => {
          const result = toggle(providerId);
          setMessage(
            result === "full"
              ? "Du kan jämföra högst tre utförarenheter."
              : null,
          );
        }}
        aria-pressed={saved}
        className="inline-flex min-h-11 items-center gap-2 rounded-xl border border-brand-primary/30 bg-white px-3 py-2 text-sm font-semibold text-brand-primary transition hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary"
      >
        {saved ? (
          <BookmarkCheck className="h-4 w-4" aria-hidden="true" />
        ) : (
          <Bookmark className="h-4 w-4" aria-hidden="true" />
        )}
        {saved ? "Sparad" : "Spara"}
      </button>
      {message && (
        <p role="status" className="mt-1 max-w-52 text-xs text-rose-700">
          {message}
        </p>
      )}
    </div>
  );
}
